import React, { ChangeEvent } from "react";
import './LabelledCheckbox.css';

interface Props {
  isChecked: boolean;
  checkboxUniqueId: string;
  labelText: string;
  onChange: ({ isChecked }: { isChecked: boolean }) => void;
}

function LabelledCheckbox(props: Props) {
  const { checkboxUniqueId, isChecked, labelText } = props;

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.onChange({ isChecked: Boolean(event.target.checked) });
  };

  return (
    <>
      <label className="form-checkbox-label" htmlFor={checkboxUniqueId}>
        {labelText}
        <input type="checkbox" className="form-checkbox-input" id={checkboxUniqueId} checked={isChecked} onChange={handleOnChange}></input>
      </label>
    </>
  );
}

export default LabelledCheckbox;
